import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import sanitizeHtml from "sanitize-html";

const SignatureCell: FC<Props> = ({ element }) => {

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.stack}`}>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(element.Signature),
          }}
        ></div>
      </div>
    </div>
  );
};

export default SignatureCell;
